import React, { useEffect, useRef, useState } from 'react';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import { useUserContext } from '../contexts/UserContext';
import toast, { Toaster } from 'react-hot-toast';
import { API_URL } from '../config/api';

export default function Navbar() {
  const { user, logout } = useUserContext();
  const navigate = useNavigate();
  const [notifCount, setNotifCount] = useState(0);
  const prevNotifCount = useRef(0);
  const audioRef = useRef(null);

  const logoutHandler = () => {
    logout();
    toast.success("Déconnexion réussie !");
    navigate('/');
  };

  useEffect(() => {
    let interval;
    const fetchNotifications = async () => {
      if (!user?._id) return;

      try {
        const res = await fetch(`${API_URL}/commandes?adminId=${user._id}`);
        const data = await res.json();
        const commandesAtraiter = data.filter(c =>
          c.status === 'en attente' || c.status === 'à livrer'
        );
        const newCount = commandesAtraiter.length;

        // Détection d'une nouvelle commande
        if (newCount > prevNotifCount.current) {
          toast("🆕 Nouvelle commande à traiter !");
          // Jouer un son de notification si tu veux
          // if (audioRef.current) audioRef.current.play();
        }

        prevNotifCount.current = newCount;
        setNotifCount(newCount);
      } catch (err) {
        console.error("Erreur notification commandes :", err);
      }
    };

    fetchNotifications();
    interval = setInterval(fetchNotifications, 60000); // toutes les 60 sec

    return () => clearInterval(interval);
  }, [user]);

  return (
    <div className="navbar-global">
      {/* React Hot Toast container */}
      <Toaster position="top-right" />

      <header className="navbar-top">
        <div className="navbar-left">
          <Link to="/accueil">
            <img
              src={`${process.env.PUBLIC_URL}/logo df.png`}
              alt="Logo"
              className="navbar-logo"
            />
          </Link>
        </div>

        <div className="navbar-center">
          <h2 className="navbar-title"> DF Manager</h2>
        </div>

        <div className="navbar-right">
          {user ? (
            <div className="navbar-user-info">
              <Link to="/Mon--profil" className="btn-profil">
                <i className="fa-solid fa-user-circle"></i> Profil
              </Link>

              <button onClick={logoutHandler} className="btn-logout">
                <i className="fa-solid fa-right-from-bracket"></i> Déconnexion
              </button>
            </div>
          ) : (
            <Link to="/" className="btn-login">Login</Link>
          )}
        </div>
      </header>

      <nav className="navbar-menu">
          <NavLink to="/Accueil" className={({ isActive }) => isActive ? 'active' : ''}>
          <i className="fa-solid fa-house"></i> Accueil
        </NavLink>

        <NavLink to="/articles" className={({ isActive }) => isActive ? 'active' : ''}>
          <i className="fa-solid fa-boxes-stacked me-2"></i> Articles
        </NavLink>

        <NavLink to="/traitement" className={({ isActive }) => isActive ? 'active notification-link' : 'notification-link'}>
          <i className="fa-solid fa-cart-shopping"></i> Mes Commandes
          {notifCount > 0 && (
            <span className="notif-badge">{notifCount}</span>
          )}
        </NavLink>

         <NavLink to="/Mes--statistiques" className={({ isActive }) => isActive ? 'active' : ''}>
          <i className="fa-solid fa-chart-line"></i> Statistiques
        </NavLink>

        <NavLink to="/trafic-web" className={({ isActive }) => isActive ? 'active' : ''}>
          <i className="fa-solid fa-globe"></i> Trafic web
        </NavLink>

        <NavLink to="/promos" className={({ isActive }) => isActive ? 'active' : ''}>
          <i className="fa-solid fa-percent"></i> Promos
        </NavLink>

        

         <NavLink to="/clients" className={({ isActive }) => isActive ? 'active' : ''}>
          <i className="fa-solid fa-users"></i> Mes clients
        </NavLink>


         {/* <NavLink to="/newsletter" className={({ isActive }) => isActive ? 'active' : ''}>
          <i className="fa-solid fa-users"></i> Newsletter
        </NavLink> */}

         <NavLink to="/affiches/pages" className={({ isActive }) => isActive ? 'active' : ''}>
         <i className="fa-solid fa-message"></i> Affiches et Messages
        </NavLink>


           <NavLink to="/AchatDepenses" className={({ isActive }) => isActive ? 'active' : ''}>
          <i className="fa-solid fa-bag-shopping"></i> Achat & Dépenses
        </NavLink>

          <NavLink to="/stocks" className={({ isActive }) => isActive ? 'active' : ''}>
          <i className="fa-solid fa-box"></i> Stocks
        </NavLink>

             <NavLink to="/mes_archives" className={({ isActive }) => isActive ? 'active' : ''}>
         <i className="fa-solid fa-folder"></i> Mes archives
        </NavLink>
      </nav>

      <audio ref={audioRef} src="/notification.mp3" preload="auto" />

      <style>{`
        .notification-link {
          position: relative;
        }

        .notif-badge {
          position: absolute;
          top: -8px;
          right: -10px;
          background-color: red;
          color: white;
          border-radius: 50%;
          padding: 2px 6px;
          font-size: 0.75rem;
          font-weight: bold;
        }
      `}</style>
    </div>
  );
}